import { Input } from 'antd';
import styled from 'styled-components';

export const InputStyled = styled(Input)`
  .ant-input:focus {
    border-color: black;
  }
`;
